import { render, staticRenderFns } from "./PurchaseEntryDetailsTable.vue?vue&type=template&id=4a41cc5f&scoped=true&"
import script from "./PurchaseEntryDetailsTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseEntryDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseEntryDetailsTable.vue?vue&type=style&index=0&id=4a41cc5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a41cc5f",
  null
  
)

export default component.exports